import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=17954708&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17954708')) {
      api.createRecord('17954708', component.options)
    } else {
      api.reload('17954708', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=17954708&", function () {
      api.rerender('17954708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/users/Index.vue"
export default component.exports